module.exports = __webpack_public_path__ + "img/my-realtor-black.393e92ea.svg";